/**
 * The tag to put in `<html lang>` for the console's current language.
 *
 * Not the app's own language code. The app codes are directory names under
 * public/locales -- `jp`, `zh_CN` -- and neither is valid BCP 47: Japanese is
 * `ja`, and an underscore is not a subtag separator at all. Writing them into
 * `lang` leaves the document claiming a language nothing recognises, so screen
 * readers fall back to the browser's own voice, `:lang()` rules never match,
 * and the browser offers to translate a page that is already translated.
 *
 * Script subtags rather than regions for Chinese: the two files differ by
 * script, not by country, and `zh-Hant` / `zh-Hans` is what a reader needs to
 * pick the right glyphs. Date formatting wants the opposite -- a region decides
 * how a date reads -- which is why dateLocale.ts keeps its own map.
 */

const DOCUMENT_LANGS: Record<string, string> = {
  en: 'en',
  zh: 'zh-Hant',
  zh_CN: 'zh-Hans',
  jp: 'ja',
  ko: 'ko',
}

export const DEFAULT_DOCUMENT_LANG = 'en'

export function documentLangFor(language: string | undefined): string {
  if (!language) return DEFAULT_DOCUMENT_LANG
  // i18next hands back the resolved language, but a region can still ride along
  // (en-GB, zh-Hant); fall back to the base before giving up.
  return (
    DOCUMENT_LANGS[language] ??
    DOCUMENT_LANGS[language.replace(/-/g, '_')] ??
    DOCUMENT_LANGS[language.split(/[-_]/)[0]] ??
    DEFAULT_DOCUMENT_LANG
  )
}
